<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div>
    <s-header name="今日热点" :noback="true"></s-header>

    <!--    <header class="home-header wrap" :class="{'active' : headerScroll}">-->
    <!--&lt;!&ndash;      <router-link tag="i" to="./category"><i class="nbicon nbmenu2"></i></router-link>&ndash;&gt;-->
    <!--      <div class="header-search">-->
    <!--        <span class="app-name">积分平台</span>-->
    <!--        <i class="iconfont icon-search"></i>-->
    <!--        <router-link tag="span" class="search-title" to="./product-list?from=home">山河无恙，人间皆安</router-link>-->
    <!--      </div>-->
    <!--      <router-link class="login" tag="span" to="./login" v-if="!isLogin">登录</router-link>-->
    <!--      <router-link class="login" tag="span" to="./user" v-else>-->
    <!--        <van-icon name="manager-o" />-->
    <!--      </router-link>-->
    <!--    </header>-->
    <nav-bar/>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>美丽乡村，人人参与</van-swipe-item>
      <van-swipe-item>最美家乡，低碳绿色</van-swipe-item>
      <van-swipe-item>以行动换积分</van-swipe-item>
      <van-swipe-item>以积分正德行</van-swipe-item>
      <van-swipe-item>以德行化新风</van-swipe-item>
    </van-swipe>
    <!--    <swiper :list="swiperList"></swiper>-->
    <!--    <div class="category-list">-->
    <!--      <div v-for="item in categoryList" v-bind:key="item.categoryId" @click="tips">-->
    <!--        <img :src="item.imgUrl">-->
    <!--        <span>{{ item.name }}</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="good">
      <!--      <header class="good-header">新品上线</header>-->
      <van-divider>最美乡村</van-divider>

      <van-skeleton title :row="1" :loading="loading">
        <van-grid :column-num="3" clickable>
          <van-grid-item v-for="(value,index) in gridValue" :key="index" :icon="value.icon" :text="value.name"/>

        </van-grid>

      </van-skeleton>
    </div>
    <div id="main" :style="{ width: '100%', height: '300px' }">
    </div>
    <div id="main2" :style="{ width: '100%', height: '300px' }">
    </div>

    <van-cell-group title="今日任务">

      <van-cell v-for="(data,index) in list" :key="index" :label="(getTaskEventType()[data.radio - 1] || {}).desc"
                :title="data.message"/>
    </van-cell-group>


  </div>
</template>

<script>

import {nextTick, onMounted, onUnmounted, reactive, toRefs} from 'vue'
import {useRouter} from 'vue-router'
// import swiper from '@/components/Swiper'
import navBar from '@/components/NavBar'
import {getHome} from '@/service/home'
import {getLocal} from '@/common/js/utils'
import {Toast} from '@vant/compat';
import {useStore} from 'vuex'
import {closeToast, showDialog, showLoadingToast} from 'vant';
import sHeader from '@/components/SimpleHeader'
import {infos} from '@/common/js/data'
import * as echarts from 'echarts';


import {getTaskList} from "@/service/task";
import {getTaskEventType} from "@/common/js/constants";


export default {
  name: 'home',
  methods: {
    getTaskEventType() {
      return getTaskEventType
    }
  },
  components: {
    // swiper,
    navBar,
    sHeader
  },
  setup() {
    let echart = echarts;

    const store = useStore()
    const router = useRouter()
    const state = reactive({
      swiperList: [{carouselUrl: "https://www.lixian.gov.cn/upload/cms/1/202207/220701151507801_11_111.png"},
        {carouselUrl: "https://www.lixian.gov.cn/upload/cms/1/202207/220701164314999_11_222.jpg"},
      ], // 轮播图列表
      isLogin: false, // 是否已登录
      headerScroll: false, // 滚动透明判断
      hots: [],
      list: [],
      newGoodses: [],
      recommends: [],
      categoryList: [],

      data: [infos.info, infos.peopleInfo, infos.gridInfo],
      gridValue: [
        {
          name: "最美家庭: 蔡学岭家庭",
          icon: "http://www.hnnxw.org.cn/uploadfile/2022/0402/20220402113553785.png",
          path: '/infoList',
          params: {name: "info", tag: 0}
        },
        {
          name: "最美党员: 陈燕萍",
          icon: "http://zmfdz.news.cn/246/EKSJ15631796486841n.jpg",
          path: '/complaint'
        }, {
          name: "最美组织: 雨溪街道雨溪社区",
          icon: "https://www.shaoyang.gov.cn/attachment/cmsfile/shaoyang/tpxw/201901/27ce3387a7404276973a90b4998bdf2f.jpg",
          path: '/infoList',
          params: {name: "publicize", tag: 0}
        }],

      loading: true
    })
    onUnmounted(() => {
      echart.dispose;
    });

    // 基础配置一下Echarts
    function initChart() {
      let chart = echart.getInstanceByDom(document.getElementById("main"));

      if (chart == null) { // 如果不存在，就进行初始化
        chart = echarts.init(document.getElementById("main"))
      }
      // 把配置和数据放这里
      chart.setOption({
        legend: {
          // Try 'horizontal'
          orient: 'vertical',
          right: 10,
          top: 'center'
        },
        xAxis: {
          type: "category",
          data: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ]
        },
        tooltip: {
          trigger: "axis"
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [
              0,
              12,
              20,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            type: "line",
            name: "用户访问量",

            smooth: true
          },
          {
            data: [
              0,
              2,
              5,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            type: "line",
            name: "用户参与量",
            smooth: true
          }

        ]
      });
      window.onresize = function () {
        //自适应大小
        chart.resize();
      };
    }

    function initChart2() {
      let chart = echart.getInstanceByDom(document.getElementById("main2"));

      if (chart == null) { // 如果不存在，就进行初始化
        chart = echarts.init(document.getElementById("main2"))
      }
      // 把配置和数据放这里
      chart.setOption({
        legend: {
          // Try 'horizontal'
          orient: 'vertical',
          right: 10,
          top: 'center'
        },
        xAxis: {
          data: ['阿毛', 'Wang', 'Jack', 'John', '王先生']
        },
        series: [
          {
            type: 'bar',
            name:'用户积分榜',
            data: [5023, 2222, 1233, 120, 1, ]
          }
        ],
        tooltip: {
          trigger: "axis"
        },
        yAxis: {
          type: "value"
        },

      });
      window.onresize = function () {
        //自适应大小
        chart.resize();
      };
    }

    onMounted(async () => {
      initChart();
      initChart2();

      const {data: {list}} = await getTaskList({pageNumber: 0, type: "PUBLISH", needAll: true})

      state.list = list
      const token = getLocal('token')
      if (token) {
        state.isLogin = true
        // 获取购物车数据.
        store.dispatch('updateCart')
      }
      showLoadingToast({
        message: '加载中...',
        forbidClick: true
      });
      const {data} = await getHome()
      // state.swiperList = data.carousels
      state.newGoodses = data.newGoodses
      state.hots = data.hotGoodses
      state.recommends = data.recommendGoodses
      state.loading = false
      closeToast()
    })

    nextTick(() => {
      window.addEventListener('scroll', () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        scrollTop > 100 ? state.headerScroll = true : state.headerScroll = false
      })
    })

    const goToDetail = (item) => {
      router.push({path: `/product/${item.goodsId}`})
    }

    const tips = () => {
      Toast('敬请期待');
    }
    const handleLink = (item) => {
      showDialog({
        title: item.name,
        messageAlign: 'left',
        message: item.message
      })
    }


    return {
      ...toRefs(state),
      goToDetail,
      tips,
      handleLink,
      initChart
    }
  },
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}

.home-header {
  position: fixed;
  left: 0;
  top: 0;
  .wh(100%, 50px);
  .fj();
  line-height: 50px;
  padding: 0 15px;
  .boxSizing();
  font-size: 15px;
  color: #fff;
  z-index: 10000;

  .nbmenu2 {
    color: @primary;
  }

  &.active {
    background: @primary;

    .nbmenu2 {
      color: #fff;
    }

    .login {
      color: #fff;
    }
  }

  .header-search {
    display: flex;
    .wh(74%, 20px);
    line-height: 20px;
    margin: 10px 0;
    padding: 5px 0;
    color: #232326;
    background: rgba(255, 255, 255, .7);
    border-radius: 20px;

    .app-name {
      padding: 0 10px;
      color: @primary;
      font-size: 20px;
      font-weight: bold;
      border-right: 1px solid #666;
    }

    .icon-search {
      padding: 0 10px;
      font-size: 17px;
    }

    .search-title {
      font-size: 12px;
      color: #666;
      line-height: 21px;
    }
  }

  .icon-iconyonghu {
    color: #fff;
    font-size: 22px;
  }

  .login {
    color: @primary;
    line-height: 52px;

    .van-icon-manager-o {
      font-size: 20px;
      vertical-align: -3px;
    }
  }
}

.category-list {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  width: 100%;
  padding-bottom: 13px;

  div {
    display: flex;
    flex-direction: column;
    width: 20%;
    text-align: center;

    img {
      .wh(36px, 36px);
      margin: 13px auto 8px auto;
    }
  }
}

.good {
  --van-grid-item-icon-size: 100px;

  .good-header {
    background: #f9f9f9;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: @primary;
    font-size: 16px;
    font-weight: 500;
  }

  .good-box {
    box-sizing: border-box;

    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .good-item {
      box-sizing: border-box;
      width: 50%;
      border-bottom: 1PX solid #e9e9e9;
      padding: 10px 10px;

      img {
        display: block;
        width: 120px;
        margin: 0 auto;
      }

      .good-desc {
        text-align: center;
        font-size: 14px;
        padding: 10px 0;

        .title {
          color: #222333;
        }

        .price {
          color: @primary;
        }
      }

      &:nth-child(2n + 1) {
        border-right: 1PX solid #e9e9e9;
      }
    }
  }
}

.floor-list {
  width: 100%;
  padding-bottom: 50px;

  .floor-head {
    width: 100%;
    height: 40px;
    background: #F6F6F6;
  }

  .floor-content {
    display: flex;
    flex-shrink: 0;
    flex-wrap: wrap;
    width: 100%;
    .boxSizing();

    .floor-category {
      width: 50%;
      padding: 10px;
      border-right: 1px solid #dcdcdc;
      border-bottom: 1px solid #dcdcdc;
      .boxSizing();

      &:nth-child(2n) {
        border-right: none;
      }

      p {
        font-size: 17px;
        color: #333;

        &:nth-child(2) {
          padding: 5px 0;
          font-size: 13px;
          color: @primary;
        }
      }

      .floor-products {
        .fj();
        width: 100%;

        img {
          .wh(65px, 65px);
        }
      }
    }
  }
}
</style>